// Área "extract" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const extract = {
  pt: {
    'extract.loading': 'Carregando extrato...',
    'extract.title': 'Extrato de Movimentações',
    'extract.defaultClient': 'Cliente',
    'extract.accountLabel': 'Conta {number}',
    'extract.print': 'Imprimir',
    'extract.exportCsv': 'Exportar CSV',
    'extract.currentBalance': 'Saldo Atual',
    'extract.totalReceived': 'Total Recebido',
    'extract.totalSent': 'Total Enviado',
    'extract.transactions': 'Transações',
    'extract.filters': 'Filtros:',
    'extract.last7': 'Últimos 7 dias',
    'extract.last30': 'Últimos 30 dias',
    'extract.last90': 'Últimos 90 dias',
    'extract.lastYear': 'Último ano',
    'extract.allTransactions': 'Todas as transações',
    'extract.onlySent': 'Apenas enviadas',
    'extract.onlyReceived': 'Apenas recebidas',
    'extract.history': 'Histórico de Transações',
    'extract.transactionCount': '{n} transação(ões) no período selecionado',
    'extract.noTransactions': 'Nenhuma transação encontrada no período selecionado.',
    'extract.makePix': 'Fazer PIX',
    'extract.pixReceived': 'PIX Recebido',
    'extract.pixSent': 'PIX Enviado',
    'extract.completed': 'Concluído',
    'extract.fromLabel': 'De: ',
    'extract.toLabel': 'Para: ',
    'extract.notInformed': 'Não informado',
    'extract.sender': 'Remetente',
    'extract.yourAccount': 'Sua Conta',
    'extract.recipient': 'Destinatário',
    'extract.you': 'Você',
    'extract.transactionId': 'ID da Transação',
    'extract.pixKey': 'Chave PIX',
    'extract.date': 'Data',
    'extract.time': 'Hora',
    'extract.description': 'Descrição',
    'extract.backToDashboard': 'Voltar ao Dashboard',
  },
  es: {
    'extract.loading': 'Cargando movimientos...',
    'extract.title': 'Movimientos de la Cuenta',
    'extract.defaultClient': 'Cliente',
    'extract.accountLabel': 'Cuenta {number}',
    'extract.print': 'Imprimir',
    'extract.exportCsv': 'Exportar CSV',
    'extract.currentBalance': 'Saldo Actual',
    'extract.totalReceived': 'Total Recibido',
    'extract.totalSent': 'Total Enviado',
    'extract.transactions': 'Transacciones',
    'extract.filters': 'Filtros:',
    'extract.last7': 'Últimos 7 días',
    'extract.last30': 'Últimos 30 días',
    'extract.last90': 'Últimos 90 días',
    'extract.lastYear': 'Último año',
    'extract.allTransactions': 'Todas las transacciones',
    'extract.onlySent': 'Solo enviadas',
    'extract.onlyReceived': 'Solo recibidas',
    'extract.history': 'Historial de Transacciones',
    'extract.transactionCount': '{n} transacción(es) en el período seleccionado',
    'extract.noTransactions': 'No se encontró ninguna transacción en el período seleccionado.',
    'extract.makePix': 'Hacer PIX',
    'extract.pixReceived': 'PIX Recibido',
    'extract.pixSent': 'PIX Enviado',
    'extract.completed': 'Completado',
    'extract.fromLabel': 'De: ',
    'extract.toLabel': 'Para: ',
    'extract.notInformed': 'No informado',
    'extract.sender': 'Remitente',
    'extract.yourAccount': 'Tu Cuenta',
    'extract.recipient': 'Destinatario',
    'extract.you': 'Tú',
    'extract.transactionId': 'ID de la Transacción',
    'extract.pixKey': 'Clave PIX',
    'extract.date': 'Fecha',
    'extract.time': 'Hora',
    'extract.description': 'Descripción',
    'extract.backToDashboard': 'Volver al Panel',
  },
  en: {
    'extract.loading': 'Loading statement...',
    'extract.title': 'Account Statement',
    'extract.defaultClient': 'Customer',
    'extract.accountLabel': 'Account {number}',
    'extract.print': 'Print',
    'extract.exportCsv': 'Export CSV',
    'extract.currentBalance': 'Current Balance',
    'extract.totalReceived': 'Total Received',
    'extract.totalSent': 'Total Sent',
    'extract.transactions': 'Transactions',
    'extract.filters': 'Filters:',
    'extract.last7': 'Last 7 days',
    'extract.last30': 'Last 30 days',
    'extract.last90': 'Last 90 days',
    'extract.lastYear': 'Last year',
    'extract.allTransactions': 'All transactions',
    'extract.onlySent': 'Sent only',
    'extract.onlyReceived': 'Received only',
    'extract.history': 'Transaction History',
    'extract.transactionCount': '{n} transaction(s) in the selected period',
    'extract.noTransactions': 'No transactions found in the selected period.',
    'extract.makePix': 'Make a PIX',
    'extract.pixReceived': 'PIX Received',
    'extract.pixSent': 'PIX Sent',
    'extract.completed': 'Completed',
    'extract.fromLabel': 'From: ',
    'extract.toLabel': 'To: ',
    'extract.notInformed': 'Not provided',
    'extract.sender': 'Sender',
    'extract.yourAccount': 'Your Account',
    'extract.recipient': 'Recipient',
    'extract.you': 'You',
    'extract.transactionId': 'Transaction ID',
    'extract.pixKey': 'PIX Key',
    'extract.date': 'Date',
    'extract.time': 'Time',
    'extract.description': 'Description',
    'extract.backToDashboard': 'Back to Dashboard',
  },
  it: {
    'extract.loading': 'Caricamento movimenti...',
    'extract.title': 'Movimenti del Conto',
    'extract.defaultClient': 'Cliente',
    'extract.accountLabel': 'Conto {number}',
    'extract.print': 'Stampa',
    'extract.exportCsv': 'Esporta CSV',
    'extract.currentBalance': 'Saldo Attuale',
    'extract.totalReceived': 'Totale Ricevuto',
    'extract.totalSent': 'Totale Inviato',
    'extract.transactions': 'Transazioni',
    'extract.filters': 'Filtri:',
    'extract.last7': 'Ultimi 7 giorni',
    'extract.last30': 'Ultimi 30 giorni',
    'extract.last90': 'Ultimi 90 giorni',
    'extract.lastYear': 'Ultimo anno',
    'extract.allTransactions': 'Tutte le transazioni',
    'extract.onlySent': 'Solo inviate',
    'extract.onlyReceived': 'Solo ricevute',
    'extract.history': 'Cronologia Transazioni',
    'extract.transactionCount': '{n} transazione(i) nel periodo selezionato',
    'extract.noTransactions': 'Nessuna transazione trovata nel periodo selezionato.',
    'extract.makePix': 'Effettua un PIX',
    'extract.pixReceived': 'PIX Ricevuto',
    'extract.pixSent': 'PIX Inviato',
    'extract.completed': 'Completato',
    'extract.fromLabel': 'Da: ',
    'extract.toLabel': 'A: ',
    'extract.notInformed': 'Non indicato',
    'extract.sender': 'Mittente',
    'extract.yourAccount': 'Il Tuo Conto',
    'extract.recipient': 'Destinatario',
    'extract.you': 'Tu',
    'extract.transactionId': 'ID Transazione',
    'extract.pixKey': 'Chiave PIX',
    'extract.date': 'Data',
    'extract.time': 'Ora',
    'extract.description': 'Descrizione',
    'extract.backToDashboard': 'Torna alla Dashboard',
  },
};

export default extract;
